module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0045.jpg?v=c700c9dc";